/*
Licensed Materials - Property of IBM
694906H
(c) Copyright IBM Corp.  2020 All Rights Reserved

US Government Users Restricted Rights - Use, duplication or disclosure restricted
by GSA ADP Schedule Contract with IBM Corp.
*/

import styled from "styled-components";
import { Link as ReactLink } from 'react-router-dom';
import theme from './PolarisLoginForm.theme'

export const FormContainer = styled.div`
    .no-bottom {
        margin-bottom: 0rem;
    }
`

export const FormFooter = styled.div`
    display: flex;
    font-size: 0.875rem;
    justify-content: center;
    margin-top: 3.5rem;
`

export const Link = styled(ReactLink)`
    color: ${props => theme(props).linkColor};
    text-decoration: underline;
`